import { Injectable } from "@angular/core";
import { createEffect, ofType, Actions } from "@ngrx/effects";
import { of } from "rxjs";
import { concatMap, map, mergeMap, switchMap } from "rxjs/operators";
import * as type from './actionTypes';
import * as CostTrackerAction from './actions';
import { CostTrackerService } from "./service";
import { IServerResponse } from "app/interface";

@Injectable()
export class CostTrackerEffect {

    constructor(
        private action: Actions,
        private costTrackerService: CostTrackerService
    ) { }

    GetCostTrackersList = createEffect(() => this.action.pipe(
        ofType(type.GET_COST_TRACKERS_LIST),
        switchMap((data) => this.costTrackerService.getCostTrackersList()),
        map((data: Array<any>) => new CostTrackerAction.CostTrackersList(data))
    ));

    CostTrackerById = createEffect(() => this.action.pipe(
        ofType(type.SEARCH_COST_TRACKER_BY_ID),
        switchMap((data: any) => this.costTrackerService.getCostTrackerById(data.payload)),
        map((data: Array<any>) => new CostTrackerAction.CostTrackerById(data))
    ));

    SaveCostTracker = createEffect(() => this.action.pipe(
        ofType(type.SAVE_COST_TRACKER),
        switchMap((data: any) => this.costTrackerService.saveCostTracker(data.payload)),
        map((data: IServerResponse) => new CostTrackerAction.SaveCostTrackerResp(data))
    ));

    DeleteCostTracker = createEffect(() => this.action.pipe(
        ofType(type.DELETE_COST_TRACKER),
        switchMap((data: any) => this.costTrackerService.deleteCostTracker(data.payload)),
        map((data: IServerResponse) => new CostTrackerAction.DeleteCostTrackerResp(data))
    ));

    GetCloudProvidersList = createEffect(() => this.action.pipe(
        ofType(type.GET_CLOUD_PROVIDERS_LIST),
        switchMap((data) => this.costTrackerService.getCloudProvidersList()),
        map((data: Array<any>) => new CostTrackerAction.CloudProvidersList(data))
    ));

    GetEventsForTracker = createEffect(() => this.action.pipe(
        ofType(type.GET_ALL_EVENTS),
        concatMap((data: any) => this.costTrackerService.getEventInfo(data.payload)),
        map((data: Array<any>) => new CostTrackerAction.GetEventsForTrackerResp(data))
    ));

    GetEventInfo = createEffect(() => this.action.pipe(
        ofType(type.GET_EVENT_INFO),
        switchMap((data: any) => this.costTrackerService.getEventInfo(data.payload)),
        map((data: Array<any>) => new CostTrackerAction.EventInfoResp(data))
    ));

    SaveEvent = createEffect(() => this.action.pipe(
        ofType(type.SAVE_EVENT),
        switchMap((data: any) => data.payload.id ? this.costTrackerService.updateEvents(data.payload) : this.costTrackerService.addEvents(data.payload)),
        map((data: Array<any>) => new CostTrackerAction.SaveEventResp(data))
    ));

    SearchCostTrackerByFields = createEffect(() => this.action.pipe(
        ofType(type.SEARCH_COST_TRACKER_BY_FIELD),
        switchMap((data: any) => this.costTrackerService.searchCostTrackerByFields(data.payload)),
        map((data) => new CostTrackerAction.CostTrackerByFieldList(data))
    ));

    GetCostTrackerContracts = createEffect(() => this.action.pipe(
        ofType(type.GET_COST_TRACKER_CONTRACTS),
        switchMap((data: any) => this.costTrackerService.getCostTrackerContracts(data.payload)),
        map((data) => new CostTrackerAction.SetCostTrackerContracts(data))
    ))
}
